import React from 'react'
import { FaIcon } from '../../App/Components/FaIcon/FaIcon'
import { faMessageBot } from '@fortawesome/pro-light-svg-icons'
import '../Chat.css'

type ChatBubbleProps = {
  onClick: () => void
  ariaLabel: string
  position?: 'left' | 'right'
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({ onClick, ariaLabel, position = 'right' }) => (
  <button
    className={`chat__bubble ${position === 'left' ? 'chat__bubble--left' : ''}`}
    onClick={onClick}
    data-testid="chat-bubble"
    aria-label={ariaLabel}
  >
    <FaIcon icon={faMessageBot} cssStyle={{ fontSize: 24 }} />
  </button>
)
